// extracted by mini-css-extract-plugin
export var features = "pages-module--features--1lBb9";
export var docsColumns = "pages-module--docsColumns--27oz6";